import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles({
  mainWrapper: {
    height: "68px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      height: "90px",
    },
  },
  incompleteWrapper: {
    backgroundColor: colors.warning100,
    position: "fixed",
    top: 0,
    display: "flex",
    justifyContent: "space-between",
    textAlign: "center",
    alignItems: "center",
    width: "100%",
    height: "68px",
    zIndex: 2,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      position: "relative"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      height: "90px",
      position: "relative"
    },
  },
  incompleteText: {
    color: colors.orange,
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    margin: "auto 0px auto 16px",
    paddingRight: "12px",
    paddingLeft: "9px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      paddingLeft: "0px",
    },
  },
  btn: {
    border: "none",
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    gap: "10px",
    color: colors.mediumGrey,
    backgroundColor: colors.veryLightOrange,
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    cursor: "pointer",
    marginRight: "16px",
    "&:hover": {
      backgroundColor: colors.primary75Blue,
      border: "none",
      color: colors.white,
      transitionDuration: "200ms",
    },
    "&:hover span:last-of-type": {
      color: colors.darkBlue2,
    },
    "& span:first-child": {
      "& path": {
        stroke: colors.orange,
      },
    },
    "& span:last-child": {
      color: colors.warning600,
    },
  },
});

export default styles;
